
import { defineComponent } from 'vue';
import FullscreenImage from '@/components/App/FullscreenImage.vue';

export default defineComponent({
	name: 'message-image',
	components: { FullscreenImage },

	props: {
		src: String,

		isWidget: {
			type: Boolean,
			default: false
		}
	},

	emits: {
		loaded: null,
		init: null
	},

	data() {
		return {
			isInit: false,
			isFull: false
		};
	},

	methods: {
		loadedImage() {
			this.$emit('loaded');
		},
		onResize(size: { width: number; height: number }) {
			if (this.isInit || !size.height) return;
			this.isInit = true;
			this.$emit('init');
		}
	}
});
